import { Pipe, PipeTransform } from '@angular/core';
import {IProduct} from '../../shared/models/product.model';

@Pipe({
    name: 'isDeviceForbiddenFor210MmPrismaXsEnclosure',
    standalone: false
})
export class IsDeviceForbiddenFor210MmPrismaXsEnclosurePipe implements PipeTransform {

  transform(product: IProduct, is280mmEnclosure: boolean): boolean {
    return product?.onlySuitableFor280mmPrismaXS && !is280mmEnclosure;
  }

}
